import React, { Component } from 'react';
import animateScrollTo from 'animated-scroll-to';
import Button from '../../../common/button/Button';
import Slider from '../../../common/Slider/Slider';

const imgsEmbedded = [
    { img: '150x60.jpg', alt: 'tamanho da imagem 150x60', content: '<div class="player-antena1" id="link-a4"><div> 150x60 px' },
    { img: '234x60.jpg', alt: 'tamanho da imagem 234x60', content: '<div class="player-antena1" id="link-a2"><div> 234x60 px' },
    { img: '320x100.jpg', alt: 'tamanho da imagem 320x100', content: '<div class="player-antena1" id="link-a3"><div> 320x100 px' },
    { img: '120x240.jpg', alt: 'tamanho da imagem 120x240', content: '<div class="player-antena1" id="link-a1"><div> 120x240 px' },
];

class EmbeddedPage extends Component {
    componentDidMount() {
        animateScrollTo(0, { speed: 700 });
    }

    // eslint-disable-next-line class-methods-use-this
    _mapImages() {
        return imgsEmbedded.map((data, index) => (
            <div className="contentEmbeddedImg" key={index}>
                <figure>
                    <img id={`img${index}`} src={`imgEmbeddedPage/${data.img}`} alt={data.alt} loading="lazy" />
                </figure>
                <p>
                    {data.content}
                </p>
            </div>
        ));
    }

    render() {
        return (
            <section className="sectionEmbedded">
                <header>
                    <h1>Incorpore o Player</h1>
                    <p className="pageSubtitle">
                        O melhor da
                        {' '}
                        <Button className="Link TextLink titleLink" to="/" title="home">Música Internacional</Button>
                        {' '}
                        Disponível em seu site
                    </p>
                </header>
                <article>
                    <div className="contentIntro">
                        <figure>
                            <img src="imgEmbeddedPage/icon.png" alt="icones de dispositivos" />
                        </figure>
                        <p>Agora é muito mais fácil de inserir um banner para o player no seu site ou blog.</p>
                        <p className="p2">Abaixo vamos mostrar como é simples inserir algumas linhas no seu site para já aparecer o nosso banner que  levará até o player.</p>
                        <p className="p3">No caso de algum usuário acessar a sua página por algum aparelho celular ou tablet, encaminharemos o usuário para nosso aplicativo.</p>
                    </div>
                    <div className="contentEmbedded">
                        <h2>Passo a Passo</h2>
                        <div className="steps">
                            <h3>1. Adicione jquery (min v1.8.2)</h3>
                            <p>inserir a seguinte linha no head caso não tenha</p>
                            <p className="textScript">
                                {'<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.8.2/jquery.min.js"></script>'}
                            </p>
                        </div>
                        <div className="steps">
                            <h3>2. Adicione nosso script</h3>
                            <p>inserir a seguinte linha no head</p>
                            <p className="textScript">
                                {'<script async src="https://www.antena1.com.br/embed/radioPlayer.min.js"></script>'}
                            </p>
                        </div>
                        <div className="step3 steps">
                            <h3>3. Adicione o player onde quiser</h3>
                            <p>Veja abaixo o modelo que se adequa melhor ao seu site e insira o código em seu site ou blog</p>
                        </div>
                        <div className="galleryEmbedded">
                            <div className="containerEmbedded">
                                <div className="contentEmbeddedImg">
                                    <figure>
                                        <img src="imgEmbeddedPage/150x60.jpg" alt="tamanho da imagem 150x60" />
                                    </figure>
                                    <p>
                                        {'<div class="player-antena1" id="link-a4"></div> 150x60 px'}
                                    </p>
                                </div>
                                <div className="contentEmbeddedImg">
                                    <figure>
                                        <img src="imgEmbeddedPage/234x60.jpg" alt="tamanho da imagem 234x60" />
                                    </figure>
                                    <p>
                                        {'<div class="player-antena1" id="link-a2"></div> 234x60 px'}
                                    </p>
                                </div>
                                <div className="contentEmbeddedImg">
                                    <figure>
                                        <img src="imgEmbeddedPage/320x100.jpg" alt="tamanho da imagem 320x100" />
                                    </figure>
                                    <p>
                                        {'<div class="player-antena1" id="link-a3"></div> 320x100 px'}
                                    </p>
                                </div>
                            </div>
                            <div className="containerEmbedded">
                                <div className="contentEmbeddedImg">
                                    <figure>
                                        <img src="imgEmbeddedPage/120x240.jpg" alt="tamanho da imagem 120x240" />
                                    </figure>
                                    <p>
                                        {'<div class="player-antena1" id="link-a1"></div> 120x240 px'}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="sliderEmbedded">
                            <Slider
                                spaceBetween={30}
                                pagination
                                centeredSlides
                                autoplay={false}
                                loop={false}
                            >
                                {this._mapImages()}
                            </Slider>
                        </div>
                    </div>
                </article>
            </section>
        );
    }
}

export default EmbeddedPage;
